import { ExternalLink } from 'lucide-react';

import { PictoTop } from '@/assets/icons-april-fr/pictos';
import InMotionCover from '@/assets/images/avantages/in&motion_cover.png'
import InMotionLogo from '@/assets/images/avantages/in&motion_logo.png'
import AprilPicto from '@/components/shared/april-picto';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useRequestCodePromo } from '@/hooks/api/use-avantages';
import { useCurrentUser } from '@/hooks/api/use-user';
import { useWhitelabel } from '@/hooks/api/use-whitelabel';
import useBrandName from '@/hooks/use-brand-name';
import { useUiStore } from '@/stores/ui-store';

const InMotion = () => {
    const brandName = useBrandName();
    const user = useCurrentUser();
    const code = user.marketing_code?.code;
    const eligible = user.eligible_code;
    const logoAMO = useWhitelabel().data?.logo_light_url;
    /* Code obtenu par « Obtenir ma réduction » (chaîne vide → aucun code). */
    const code_promo = (useUiStore((s) => s.codePromoUser) as string | null) || null;
    const requestCode = useRequestCodePromo();
    const postRequestCode = ({ campaign }: { campaign: string }) => requestCode.mutate({ campaign });

    return (
        <div className="mt-6">
            <Card>
                <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                            <img src={InMotionCover} alt="In&Motion" className="w-full rounded-lg" />
                        </div>
                        <div className="md:col-span-8">
                            <div className="flex items-center gap-3 mb-6">
                                <img src={logoAMO} alt={brandName} className="h-[50px]" />
                                <img src={InMotionLogo} alt="In&Motion" className="h-[35px]" />
                            </div>
                            <h3 className="text-primary font-bold text-lg">
                                Achetez un airbag et <strong>bénéficiez de 3 mois de location offerts à la In&box formule Révolution annuelle</strong>
                            </h3>
                            <p className="mt-6 text-muted-foreground">
                                {brandName} et son partenaire In&Motion s'engagent en faveur de votre sécurité avec une offre privilège !
                            </p>

                            <p className="mt-6 font-semibold">Comment bénéficier de cette offre ?</p>
                            <ol className="mt-2 space-y-2 text-sm text-muted-foreground list-decimal list-inside">
                                <li>Après avoir souscrit une assurance Moto ou Scooter {brandName} et acheté un airbag doté de la technologie In&motion</li>
                                <li>Rendez-vous sur le site <a href="http://www.inemotion.com/fr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">http://www.inemotion.com/fr</a> ou téléchargez l'application « My In&box » (disponible sur l'App store ou Play store)</li>
                                <li>Cliquez sur l'onglet « Adhésion » depuis le site internet ou « Créer un compte » depuis l'appli, puis cliquez sur le logo « {brandName} »</li>
                                <li>Saisissez votre e-mail et l'immatriculation de votre véhicule assuré {brandName} et poursuivez la création de votre compte client</li>
                            </ol>

                            {eligible ? (
                                <div className="mt-6 p-6 rounded-lg border bg-muted/30">
                                    <div className="flex items-center gap-2 mb-4">
                                        <AprilPicto icon={PictoTop} size="md" />
                                        <p className="font-semibold text-sm uppercase text-foreground">Votre code exclusif</p>
                                    </div>
                                    {code && (
                                        <Badge variant="outline" className="text-lg px-6 py-2 border-primary text-foreground font-mono">
                                            {code}
                                        </Badge>
                                    )}
                                    {code_promo && (
                                        <Badge variant="outline" className="text-lg px-6 py-2 border-primary text-foreground font-mono">
                                            {code_promo}
                                        </Badge>
                                    )}
                                    {(!code && !code_promo) && (
                                        <Button
                                            variant="outline"
                                            className="cursor-pointer"
                                            onClick={() => postRequestCode({campaign: 'I&MAPRIL'})}
                                        >
                                            Obtenir ma réduction
                                        </Button>
                                    )}
                                </div>
                            ) : (
                                <p className="mt-6 text-sm text-muted-foreground">Vous n'êtes pas éligible à l'offre proposée.</p>
                            )}

                            <Button asChild className="mt-6 cursor-pointer">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.april-moto.com/april-moto-et-inemotion-vous-offrent-3-mois-delocation-a-inebox/" className="no-underline text-white" aria-label="Détails de l'offre In&Motion">
                                    <ExternalLink className="w-4 h-4" aria-hidden="true" />
                                    Détails de l'offre
                                </a>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default InMotion;
